import React from 'react';
import { Box, styled } from '@mui/material';
import { keyframes } from '@mui/system';

// Define the keyframes for the drawing animation
const draw = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

// Create a styled component for the animated text
const AnimatedText = styled('text')`
  font-size: 48px;
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  fill: none;
  stroke: #fff;
  stroke-width: .8;
  stroke-dasharray: 450;
  stroke-dashoffset: 450;
  animation: ${draw} 6.5s ease-in-out infinite alternate;
`;

const AnimatedBrewzLogo = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        '@media (max-width: 600px)': {
          svg: {
            width: '160px',
            height: '48px',
          },
        },
      }}
    >
      <svg
        width="260"
        height="80"
        viewBox="0 0 275 80"
        style={{ marginLeft: '10px', maxWidth: '100%', height: 'auto' }}
      >
        <AnimatedText
          x="50%"
          y="50%"
          dy=".45em"
          textAnchor="middle"
          style={{ fontSize: '48px' }}
        >
          BREWZ 101
        </AnimatedText>
      </svg>
    </Box>
  );
};

export default AnimatedBrewzLogo;

